import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../../../components/Administration/General/Admin-breadcrumb'
import { useHistory } from 'react-router-dom'
import DatePickerHandle from '../../../components/Onboard/OnboardComponents/KeyboardDatePicker';
import Filter_Icon from './../../../assets/images/Filter_Icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { OnboardSelect } from '../../../components/Onboard/OnboardComponents/Dropdown/Select';
import { getAquaaValidFromData, getIcedReportsAccountsData } from '../../../actions/Applications/aquaa.action';


const IcedReports = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const aquaaValidFrom = useSelector((state) => state.aquaaReducer.aquaaValidFrom);
    const icedReportsAccounts = useSelector((state) => state.aquaaReducer.icedReportsAccounts);
   const RoleId = localStorage.getItem('Role_id');

    const [selectedAccount, setSelectedAccount] = useState();
    
    useEffect(()=>{
        dispatch(getIcedReportsAccountsData(RoleId));
        dispatch(getAquaaValidFromData());
    },[dispatch,RoleId])

      function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }

  const [selectedDate, setSelectedDate] = useState(() => {
    const fromDateString = aquaaValidFrom?.[0]?.fromDate;
    return {
      From: fromDateString ? formatDate(new Date(fromDateString)) : null,
      To: formatDate(new Date())
    };
  });
  useEffect(() => {
    const fromDateString = aquaaValidFrom?.[0]?.fromDate;
    if (fromDateString) {
      setSelectedDate(prev => ({
        ...prev,
        From: formatDate(new Date(fromDateString))
      }));
    }
  }, [aquaaValidFrom]);
  
  const FromDateHandler = (date) => {
    setSelectedDate({...selectedDate, From: (date === null || date === undefined) ? null : formatDate(date)});
    
  }
  
  const ToDateHandler = (date) => {
    setSelectedDate({...selectedDate, To: (date === null || date === undefined) ? null : formatDate(date)});
    
  }

  const addValueToAccount = (name, selectedOption) => {
    if (name !== 'Select') {
      setSelectedAccount((prevFormData) => ({
        ...prevFormData,
        [name]: selectedOption,
      }));
    }
  };

 const selectedAccountfordispatch = selectedAccount === null || selectedAccount === undefined ? '' : selectedAccount;

  console.log('selectedAccount',selectedAccountfordispatch)
  return (
    <div>
    <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/icedapplications')} label2='ICED' isActive3={false} label3='ICED Reports'/>
<section className='App_Layout'>
       <main className='Title_bar'> <div className='Applications_Title'> ICED Reports </div>
       </main>
      </section>
     <section className='Filter_aquaa'>
            <main className='aquaa_filter_img'>
              <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '30px', paddingLeft: '30px' }} />
            </main>
            <div className='aquaaFilterAlignment'>
              
              <main className='Aquaa_dropdown'>
                <DatePickerHandle  label='From' id='label'  value={(selectedDate?.From === undefined || selectedDate?.From === null) ? null : selectedDate?.From}
                onChange={(date) => FromDateHandler(date)}/>
              </main>
              <main className='Aquaa_dropdown'>
                <DatePickerHandle  label='To' id='label' value={(selectedDate?.To === undefined || selectedDate?.To === null) ? null : selectedDate?.To}
                onChange={(date) => ToDateHandler(date)}/>
              </main>
              <main className='Aquaa_dropdown'>
                          <label HtmlFor='country'>Account</label>
                          <OnboardSelect data={icedReportsAccounts} name='Account' value='Account' id='ID' marginTop='10px'
                            editValue='' addValueToQueue= { addValueToAccount } passFullObject={true} />
                        </main>
            <div className='btn_adduser' onClick={()=>{window.location.href = `${process.env.REACT_APP_BASE_URL}api/usp/ICEDGetTicketDataByRole?RoleId=${RoleId}&AccountID=${selectedAccountfordispatch.Account.ID}&StartDate=${selectedDate.From}&EndDate=${selectedDate.To}&format=excel&filename=ICEDReport_Excel.xlsx`}}>Export</div>

            </div>
          </section>
    
  
    </div>
  )
}

export default IcedReports